import { SignUpPayload } from '@app/core/features/auth';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Component, Input, OnInit } from '@angular/core';
import { relativePaths } from '@app/constants';
import { authActions, authSelector } from '@app/core/store/auth/auth.slice';

@Component({
  selector: 'app-sign-up-free',
  templateUrl: './sign-up-free.component.html',
  styleUrls: ['./sign-up-free.component.scss'],
})
export class SignUpFreeComponent implements OnInit {
  @Input() showHeader = true;
  public userLogin = true;
  isFetching$: Observable<boolean>;
  error$: Observable<string | null>;
  relativePaths = relativePaths;
  signup$: any;

  constructor(private store: Store<{}>) {}

  ngOnInit() {
    this.signup$ = this.store.select(authSelector.signup);
  }

  handleSignUpFree({ firstName, lastName, email, password, currentZipCode }): void {
    const body = new SignUpPayload(firstName, lastName, email, password, currentZipCode);
    this.store.dispatch(authActions.signup({ body, isSignUpPremium: false, plan: null }));
  }
}
